<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
        <div class="p-formgrid p-grid p-col-12 p-ml-2">
          <div class="p-col-12 p-lg-6">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("main_organize") }}</label>
                <Button
                  @click="showOrganize = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="organize_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                :rowHover="true"
                
                :selection.sync="selectedOrganizeData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="organize_name"
                  :header="$t('id_operating_name')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.organize_id }}</div>
                    {{ dataTable.data.organize_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')"  headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col-6">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            organizeDelete = dataTable.data;
                            alertDisplay(organizeDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
            <hr />
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("local_event") }}</label>
                <Button
                  @click="showResponseArea = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="responseArea_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                :rowHover="true"
                
                :selection.sync="selectedResponseAreaData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="province_name"
                  :header="$t('province')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.tambon_id }}</div>
                    {{ dataTable.data.province_name }}
                  </template>
                </Column>
                <Column
                  field="amphur_name"
                  :header="$t('amphur')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.amphur_name }}
                  </template>
                </Column>
                <Column
                  field="tambon_name"
                  :header="$t('tambon')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.tambon_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            responseAreaDelete = dataTable.data;
                            alertDisplay(responseAreaDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <div class="p-col p-ml-3 p-mt-3">
            <div class="p-formgrid p-col p-grid">
              <div class="p-field p-col-12 p-lg-5">
                <label>{{ $t("startDate") }}</label>
                <Calendar
                  dateFormat="dd/mm/yy"
                  :showButtonBar="true"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  yearRange="2000:2050"
                  :locale="th"
                  id="startDate"
                  v-model="startDate"
                ></Calendar>
              </div>
              <div class="p-field p-col-12 p-lg-5">
                <label>{{ $t("toDate") }}</label>
                <Calendar
                  dateFormat="dd/mm/yy"
                  :showButtonBar="true"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  yearRange="2000:2050"
                  :locale="th"
                  id="toDate"
                  v-model="toDate"
                ></Calendar>
              </div>
            </div>

            <div class="p-formgrid p-col p-grid p-mt-3">
              <div class="p-field p-col-11">
                <label>{{ $t("disaster_type") }}</label>
                <MultiSelect
                  v-model="disasterTypeSelected"
                  :options="disasterTypeOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div class="p-field p-col-1 p-lg-1 p-mt-5">
                <Button
                  @click="disasterTypeSelected = null
                          multiSelectClearFilerValue +=1"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-2"
                />
              </div>
            </div>
            <span class="p-invalid p-ml-2" v-if="error_disaster == true">{{
              $t("table_validate")
            }}</span>

            <div class="p-formgrid p-grid p-col p-mt-3 p-mb-4">
              <div class="p-field p-col-12 p-lg-6">
                <label for="disasterStatusOptions">{{
                  $t("disaster_status")
                }}</label>
                <Dropdown
                  v-model="disasterStatusSelect"
                  :options="disasterStatusOptions"
                  optionLabel="name"
                  :placeholder="$t('placeholderSelectBox')"
                >
                  <template #value="disasterStatusOptions">
                    <div v-if="disasterStatusOptions.value">
                      <div>{{ disasterStatusOptions.value.name }}</div>
                    </div>
                    <span v-else>
                      {{ disasterStatusOptions.placeholder }}
                    </span>
                  </template>
                  <template #option="disasterStatusOptions">
                    <div>{{ disasterStatusOptions.option.name }}</div>
                  </template>
                </Dropdown>
                <div class="p-invalid" v-if="error_disasterStatus == true" style="margin-top:.5rem  ;" >
                  กรุณาระบุข้อมูล {{$t("disaster_status")}}</div>
              </div>
            </div>

            <label class="p-col">{{ $t("level_effect") }}</label>
            <div class="p-formgrid p-grid p-col p-mt-3">
              <div class="p-field-checkbox p-mr-4 p-ml-2">
                <Checkbox id="ch_1" name="ch_1" value="0" v-model="checked" />
                <label>{{ $t("ch_1") }}</label>
              </div>
              <div class="p-field-checkbox p-mr-4">
                <Checkbox
                  id="check_level_1"
                  name="check_1"
                  value="1"
                  v-model="checked"
                />
                <label>{{ $t("level_1") }}</label>
              </div>
              <div class="p-field-checkbox p-mr-4">
                <Checkbox
                  id="check_level_2"
                  name="check_2"
                  value="2"
                  v-model="checked"
                />
                <label>{{ $t("level_2") }}</label>
              </div>
              <div class="p-field-checkbox p-mr-4">
                <Checkbox
                  id="check_level_3"
                  name="check_3"
                  value="3"
                  v-model="checked"
                />
                <label>{{ $t("level_3") }}</label>
              </div>
              <div class="p-field-checkbox p-mr-4">
                <Checkbox
                  id="check_level_4"
                  name="check_4"
                  value="4"
                  v-model="checked"
                />
                <label>{{ $t("level_4") }}</label>
              </div>
              <div class="p-field-checkbox p-mr-4">
                <Checkbox
                  id="check_level_5"
                  name="check_5"
                  value="5"
                  v-model="checked"
                />
                <label>{{ $t("level_5") }}</label>
              </div>
            </div>

            <div class="p-field p-col">
              <div class="p-formgrid p-grid p-mt-4 p-jc-end">
                <div class="p-field p-col-12 p-mt-2">
                  <!-- <Button
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info p-mr-3"
                    style="background-color: green"
                  /> -->

                  <Button
                    @click="clearSearchField()"
                    :label="$t('clearBtn')"
                    class="p-button-clear p-mr-3"
                  />
                  <Button
                    @click="search()
                    cou = true"
                    :label="$t('searchBtn')"
                    class="p-button-info p-mr-2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-formgrid p-grid p-col p-mt-1">
              <text-footer
                :data="Data_text_Footer"
                :checkShow="text_Footer"
                :countItem="table.length.toLocaleString('en-US')"
              />
        </div>
      </div>
    </Fieldset>

    <!-- :contentStyle="{ 'overflow-y': 'scroll' }" -->

    <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :style="{ width: '80%' }"
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
        :parentmessage="parentmessage_organize"
      ></organize-table>
    </Dialog>

    <Dialog
      :modal="true"
      :header="$t('ResponseAreaModalHeader')"
      :visible.sync="showResponseArea"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <response-area-table
        @selectResponseArea="selectResponseArea_passValue"
        :parentmessage="parentmessage_area"
      ></response-area-table>
    </Dialog>

    <div class="card p-fluid p-mt-2">
      <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
      <DataTable
        :value="table"
        :scrollable="true"
      scrollHeight="500px"
        :paginator="true"
        :sortOrder="1"
        sortField="index"
        :rows="10"
        dataKey="id"
        :rowHover="true"
        :filters="filters"
        ref="dt"
        :exportFilename = "`รายงานเหตุเพลิงไหม้(ว.๘/๐๐๑)-${date}`"
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
      <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
      <template #header>
          <div class="p-grid p-col " >
            
            <!-- Doe : PDF 1/3 -->
            <div class="table-header "  style="padding: 7px;"   >
              <Button
                    
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info "
                   
                    style="background-color: green;"
                  />
            </div>
            <div class="table-header " style="padding: 7px;"  >  
              <SplitButton label="ส่งออก PDF" :model="items" 
                          class="p-button-raised p-button-danger "
                          style="background-color: #f33737; "
                          ></SplitButton>
            </div>
            <!-- Doe : PDF 1/3 จบ -->

            <!-- Doe PDF เลือกได้  1/5   -->
            <div class="table-header" id="TABLE_EDIT" style="padding: 7px;"  >
                <Button
                @click="EditPDF()"
                icon="pi pi-cog"
                :label="'ตั้งค่า'"
                style="background-color: #0288D1;
                       border: 1px solid #0288D1;"
                />
            </div>
            <!-- Doe PDF เลือกได้  1/5 จบ  -->

            <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

              <!-- Doe ค้นหา  1/5 -->
              <span class="p-input-icon-left" v-if="columns_disabled && cou" >    
                    <i class="pi pi-search" />
                    <InputText
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
                <span class="p-input-icon-left" v-else >
                    <i class="pi pi-search" />
                    <InputText
                    disabled
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
              <!-- Doe ค้นหา  1/5 จบ-->

            </div>
          </div>
        </template>
        <!-- <template #header>
          <div class="table-header p-col-12 p-lg-3" style="margin-left: auto">
            <span class="p-input-icon-left">
              <i class="pi pi-search" /><InputText
                v-model="filters['global']"
                :placeholder="$t('searchHeader')"
              />
            </span>
          </div>
        </template> -->
        <template #empty>{{ $t("TableEmpty") }}</template>
        <!--Doe : เพิ่มลำดับ 2/4-->
        <div v-if="columns_index == true">
          <Column
            field="index"
            :header="'ลำดับ'"
            :sortable="true"
            :headerStyle="{width: '8rem',textAlign:'center'}"
          >
            <template #body="dataTable">  
              <div hidden>{{ dataTable.data.system_id }}</div>
              <div class="table_row">
                {{ dataTable.data.index }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
        <!--Doe : เพิ่มลำดับ 2/4 จบ-->
        
        <div v-if="columns_date == true">
          <Column
            field="date"
            :header="$t('id_help_receive')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="(dataTable.data.date == null)">-</div>
              {{ dataTable.data.date }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_disaster == true">
          <Column
            field="disaster"
            :header="$t('disaster_type')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              {{ dataTable.data.disaster }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_detail == true">
          <Column
            field="detail"
            :header="$t('disaster_detail')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.detail != null">
                {{ dataTable.data.detail }}
              </div>
              <div v-else>-</div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_event_level == true">
          <Column
            field="event_level"
            :header="$t('level_effect')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <!-- {{ dataTable.data.event_level }} -->

              <div v-if="dataTable.data.event_level == '1'" class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#00BFFF', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.event_level }}
                  </div>
              </div>
              <div v-else-if="dataTable.data.event_level == '2'" class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#006400', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.event_level }}
                  </div>
              </div>
              <div v-else-if="dataTable.data.event_level == '3'" class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#FFFF00', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.event_level }}
                  </div>
              </div>
              <div v-else-if="dataTable.data.event_level == '4'" class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#FF8C00', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.event_level }}
                  </div>
              </div>
              <div v-else-if="dataTable.data.event_level == '5'" class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#FE0000', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.event_level }}
                  </div>
              </div>
              <div v-else class="table_row">
                  <div :style="{color: '#fff', backgroundColor:'#A09B9B', display: 'inline-flex',
                        padding: '5px', paddingLeft: '15px',paddingRight: '15px' ,
                        color:'#002678',fontWeight:'bolder', borderRadius:'10px'}">
                      {{ dataTable.data.event_level }}
                  </div>
              </div>

            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_event_name == true"> 
          <Column
            field="event_name"
            :header="$t('event_name')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              {{ dataTable.data.event_name }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_location == true"> 
          <Column
            field="location"
            :header="$t('disaster_location')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.location != ''">
                {{ dataTable.data.location }}
              </div>
              <div v-else>-</div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_operating_name == true"> 
          <Column
            field="operating_name"
            :header="$t('main_organize')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.event_operator_table == '[]'">-</div>
              <div v-else>
                <div
                  v-for="operator in JSON.parse(
                    dataTable.data.event_operator_table
                  )"
                  :key="operator.operating_id"
                >
                  <div v-if="operator.organize[0] == '1'">
                    {{ operator.operating_name }}
                  </div>
                  <div v-else>-</div>
                </div>
              </div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_status == true">   
          <Column
            field="status"
            :header="$t('disaster_status')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <!-- Doe : เพิ่ม แถบสี -->
              <div v-if="dataTable.data.event_status == 'onworking'" class="table_row">
                <div :style="{color: '#fff', backgroundColor:'#F1C40F', display: 'inline-flex' , padding: '5px', paddingLeft: '15px',paddingRight: '15px' , borderRadius:'10px'}">
                  <!-- {{$t("onworking")}} -->
                  {{ dataTable.data.status }}
                  </div>

              </div>

              <div v-else-if="dataTable.data.event_status == 'finish'"  class="table_row">
            
                <div :style="{color: '#fff', backgroundColor:'#2ECC71', display: 'inline-flex' , padding: '5px', paddingLeft: '15px',paddingRight: '15px', borderRadius:'10px'}">
                  <!-- {{$t("finish")}} -->
                  {{ dataTable.data.status }}
                  </div>

              </div>
              
              <div v-else  class="table_row">
                <div :style="{color: '#fff', backgroundColor:'#E74C3C', display: 'inline-flex' , padding: '5px', paddingLeft: '15px',paddingRight: '15px', borderRadius:'10px'}">
                  <!-- {{$t("notify")}} -->
                  {{ dataTable.data.status }}
                  </div>
              </div>
              <!-- Doe : เพิ่ม แถบสี จบ -->
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <!-- <Column :header="$t('export')" :sortable="true" headerStyle="width: 150px">
					<template #body >
						<Button @click="exportCSV($event)" label="ส่งออก" icon="pi pi-download" class="p-button-export" />
					</template>
				</Column> -->
      </DataTable>
    </div>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Doe PDF เลือกได้  -->
    <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" 
    :style="{ width: '25rem' }"  
    :contentStyle="{ 'overflow-y': 'visible' }"
    > 
    <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
        <div style="margin: 2.5rem 1rem 0 1rem;">
          <div class="p-formgrid p-grid">
              <div class="p-field p-col-12">
          
                      <MultiSelect
                        v-model="columnsSelectorDialog"
                        :options="columns"
                        optionLabel="title"
                        :placeholder="$t('placeholderSelectBox')"
                        :filter="true"
                        class="multiselect-custom"
                        :clearFilterMultiSelect="multiSelectClearFilerValue"
                      >
                        <template #value="slotProps">
                          <div
                            class="item item-value"
                            v-for="option of slotProps.value"
                            :key="option.dataKey"
                          >
                            <div>{{ option.title }}</div>
                          </div>
                          <template
                            v-if="!slotProps.value || slotProps.value.length === 0"
                          >
                            {{ $t("placeholderSelectBox") }}
                          </template>
                        </template>
                        <template #option="slotProps">
                          <div class="item">
                            <div >{{ slotProps.option.title }}</div>
                          </div>
                        </template>
                      </MultiSelect>
                      <div style="margin-top: 1rem; 
                                  display:flex;
                                  justify-content: flex-end;">
                        <Button
                        @click="ClearEditPDF()
                                multiSelectClearFilerValue +=1"
                        class="p-button-clear"
                        :label="'ล้างข้อมูล'"
                        style="margin-right: 1rem;"
                        />
                        <Button
                        @click="SelectAllEditPDF()"
                        class="p-button-info"
                        :label="'เลือกทั้งหมด'"
                        

                        />
                      </div>
                      
              </div>
          </div>
        </div>
        <template #footer>
          <div>
            <Button
            @click="CloseEditPDF()"
            :label="'ยกเลิก'"
            icon="pi pi-times"
            class="p-button-text"
            />
            <Button
            @click="SaveEditPDF()"
            :label="'บันทึก'"
            icon="pi pi-check"
            class="p-button-text"
            />
          </div>
        </template>
      
      </Dialog>
       <!-- Doe PDF เลือกได้ -->

  </div>
</template>

<script>
import organizeTable from "../OrganizeMultiSelectTable";
import responseAreaTable from "../ResponseAreaTable";
// Doe : PDF 2/3 
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from "moment";
import textFooter from "../../../mixins/textFooter_Search_html"

export default {
  name: "report-daily-fire",
  components: {
    organizeTable,
    responseAreaTable,
    textFooter
  },
  data() {
    return {
      multiSelectClearFilerValue:0,
      date: moment().locale('th').add(543, 'year').format('l'),
      // Doe ค้นหา  2/5 
      filter:"",
      cou:false,
      cloneTable:[],
      // Doe ค้นหา  2/5 จบ

      startDate: "",
      toDate: "",
      table: [],
      filters: {},
      displayConfirmation: false,
      showOrganize: false,
      showResponseArea: false,

      disasterTypeOptions: [],
      disasterTypeSelected: null,

      disasterStatusOptions: [
        { id: "getall", name: this.$i18n.t("selectAll") },
        { id: "onworking", name: this.$i18n.t("onworking") },
        { id: "finish", name: this.$i18n.t("finish") },
        { id: "notify", name: this.$i18n.t("notify") }, //เพิ่ม เลือกแจ้งเหตุ
      ],
      disasterStatusSelect: { id: "getall", name: this.$i18n.t("selectAll") },

      selectedOrganizeData: null,
      organize_table: [],

      selectedResponseAreaData: null,
      responseArea_table: [],

      organizeDelete: null,
      responseAreaDelete: null,

      checked: [],
      error_disaster: false,
      error_disasterStatus: false,
      loading: false,

      parentmessage_organize: null,
      parentmessage_area: null,

      // Doe PDF เลือกได้  2/5
      setPDF_Hor:"l",
      setPosition_Hor:[802,34,802,570],
      setPDF_Ver:"p",
      setPosition_Ver:[570,34,575,815],
      setPDF_Styles:"grid",
      setnamePDF:"ตารางรายงานเหตุเพลิงไหม้",
      setPDF_fillColor:[95,154,250],
      setPDF_Margin:{ left: 15 ,right: 15 },

      PDF_minCellWidthVer: 70,
      PDF_FontHeaderVer:15,
      PDF_FontBodyVer:12,

      PDF_BodySizeSelect:{},
      PDF_BodySize:{
                          index: {cellWidth: 35},
                          date:{cellWidth: 45},
                          disaster:{cellWidth: 80},
                          detail:{cellWidth:80},

                          event_level:{cellWidth:55},
                          status:{cellWidth:55},
      },
      
      PDF_minCellWidthHor: 70,
      PDF_FontHeaderHor:15,
      PDF_FontBodyHor:12,

      PDF_BodySizeHorSelect:{},
      PDF_BodySizeHor:{
                          index: {cellWidth: 35},
                          date:{cellWidth: 45},
                          disaster:{cellWidth: 90},
                          detail:{cellWidth:80},

                          event_level:{cellWidth:55},
                          status:{cellWidth:80}, 
      },
      columns:[
                  {title: "ลำดับ", dataKey: "index" },
                  {title: "วัน-เวลาที่รับแจ้งเหตุ", dataKey: "date" },
                  {title: "ประเภทสาธารณภัย", dataKey: "disaster" },
                  {title: "ลักษณะที่เกิดเหตุ", dataKey: "detail"},
                  {title: "ระดับความรุนแรง", dataKey: "event_level"},
                  {title: "ชื่อเหตุการณ์", dataKey: "event_name"},
                  {title: "สถานที่เกิดเหตุ", dataKey: "location"},
                  {title: "หน่วยงานหลัก", dataKey: "operating_name"},
                  {title: "สถานะเหตุการณ์", dataKey: "status"},

              ],

      columnsSelector:null,
      columnsSelectorDialog:null,
      
      displayEditPDF:false,

      columns_index:true,
      columns_date:true,
      columns_disaster:true,
      columns_detail:true,
      columns_event_level:true,
      columns_event_name:true,
      columns_location:true,
      columns_operating_name:true,

      columns_status:true,
      
      columns_disabled:true,
      GetData_ColumnsSearch:[],
      // Doe PDF เลือกได้  2/5  จบ
      // 
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"หน่วยงานหลัก",
          textShow:"",
        },
        {
          DataName:"พื้นที่เกิดเหตุ",
          textShow:"",
        },
        {
          DataName:"จากวันที่",
          textShow:"",
        },
        {
          DataName:"ถึงวันที่",
          textShow:"",
        },
        {
          DataName:"ประเภทสาธารณภัย",
          textShow:"",
        },
        {
          DataName:"สถานะเหตุการณ์",
          textShow:"",
        },
        {
          DataName:"ระดับความรุนแรง",
          textShow:"",
        },
      ],
      // Doe : PDF 3/3
      items: [
				{
					label: ' แนวตั้ง',	
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวตั้ง', life: 3000});

                let columns = this.columnsSelector

                const Body_setCenter = ["index","event_level","status"]
                
                const fill_row_detail = [
                  {
                    name_row:"event_level",
                    detail_row:[
                    {
                      check_text:"1",
                      fill_color:[0,144,42]
                    },
                    {
                      check_text:"2",
                      fill_color:[146,209,79]
                    },
                    {
                      check_text:"3",
                      fill_color:[252,252,37]
                    },
                    {
                      check_text:"4",
                      fill_color:[254,123,0]
                    },
                    {
                      check_text:"5",
                      fill_color:[254,0,0]
                    }],
                  },
                ]

                const PintPDF = {
                  streak:this.setPDF_Ver,
                  setPosition:this.setPosition_Ver,
                  PDF_Styles:this.setPDF_Styles,
                  data:this.$refs.dt.processedData,
                  columns:columns,
                  columnsStyles:this.PDF_BodySizeSelect,
                  FileName:this.setnamePDF,
                  checkBody_Center:true,
                  Body_Center:Body_setCenter,
                  Col_FontSize:this.PDF_FontHeaderVer,
                  Body_FontSize:this.PDF_FontBodyVer,
                  minCell:this.PDF_minCellWidthVer,
                  marginPDF:this.setPDF_Margin,
                  fillColorPDF:this.setPDF_fillColor,
                  // 
                  check_fill_row:true,
                  fill_row_detail:fill_row_detail,
                }
                this.printPDF(PintPDF)

            } 
              }
            },
			
				{
					label: 'แนวนอน',
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวนอน', life: 3000});
            
            let columns = this.columnsSelector

                const Body_setCenter = ["index","event_level","status"]
                
                const fill_row_detail = [
                  {
                    name_row:"event_level",
                    detail_row:[
                    {
                      check_text:"1",
                      fill_color:[0,144,42]
                    },
                    {
                      check_text:"2",
                      fill_color:[146,209,79]
                    },
                    {
                      check_text:"3",
                      fill_color:[252,252,37]
                    },
                    {
                      check_text:"4",
                      fill_color:[254,123,0]
                    },
                    {
                      check_text:"5",
                      fill_color:[254,0,0]
                    }],
                  },
                ]

                const PintPDF = {
                  streak:this.setPDF_Hor,
                  setPosition:this.setPosition_Hor,
                  PDF_Styles:this.setPDF_Styles,
                  data:this.$refs.dt.processedData,
                  columns:columns,
                  columnsStyles:this.PDF_BodySizeHorSelect,
                  FileName:this.setnamePDF,
                  checkBody_Center:true,
                  Body_Center:Body_setCenter,
                  Col_FontSize:this.PDF_FontHeaderHor,
                  Body_FontSize:this.PDF_FontBodyHor,
                  minCell:this.PDF_minCellWidthHor,
                  marginPDF:this.setPDF_Margin,
                  fillColorPDF:this.setPDF_fillColor,
                  // 
                  check_fill_row:true,
                  fill_row_detail:fill_row_detail,
                }
                this.printPDF(PintPDF)
            }
            }
          },
        ],
      // Doe : PDF 3/3 จบ
    };
  },
  watch: {
    showOrganize(val) {
      if (val == true) {
        if (this.organize_table.length > 0) {
          this.parentmessage_organize = this.organize_table;
        } else {
          this.parentmessage_organize = [];
        }
      }
    },

    showResponseArea(val) {
      if (val == true) {
        if (this.responseArea_table.length > 0) {
          this.parentmessage_area = this.responseArea_table;
        } else {
          this.parentmessage_area = [];
        }
      }
    },

    disasterTypeOptions(val) {
      if (val != null) {
        this.disasterTypeSelected = val;
      }
    },

    disasterTypeSelected(val) {
      if (val != null) {
        this.error_disaster = false;
        if (val.length == 0) {
          this.disasterTypeSelected = null;
        }
      }
    },
    disasterStatusSelect(val) {
      if (val != null) {
        this.error_disasterStatus = false;
        if (val.length == 0) {
          this.disasterStatusSelect = null;
        }
      }
    },

    // table(val) {
    //   if (val.length > 0) {
    //     this.loading = false;
    //   } else {
    //     this.loading = true;
    //   }
    // },
    // Doe PDF เลือกได้
    columnsSelector(val){
      
      if (val.length == 0) {
        this.table = []
      }else{
        this.table = this.cloneTable
      }
    },
  },
  async created() {

    this.checked = ["0", "1", "2", "3", "4", "5"];
    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-02" },
      })
      .then((response) => {
        this.disasterTypeOptions = response.data.data;
      });

      // Doe PDF เลือกได้  4/5  
      this.columnsSelector = this.columns
      this.PDF_BodySizeSelect = this.PDF_BodySize
      this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor

      // Doe PDF เลือกได้  4/5  จบ

      this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)
  },
  mounted() {},
  methods: {
    exportCSV() {
      if (this.table != "") {
      this.$refs.dt.exportCSV();
      }
    },

    selectedOrganize_passValue(variable) {
      this.showOrganize = false;
      if (variable != null) {
        this.organize_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.organize_table.push(variable[i]);
        }
      }
    },

    selectResponseArea_passValue(variable) {
      this.showResponseArea = false;
      if (variable != null) {
        this.responseArea_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.responseArea_table.push(variable[i]);
        }
      }
    },

    // Doe ค้นหา  3/6 
    searchTable(){
      this.ms = true
      if (this.filter != "") {
        // console.log("4444")
        this.table = this.cloneTable.filter((item) => {
          if (item.date == null || item.date == "null") {
                    item.date = "-"
                  }
                  if (item.detail == null || item.detail == "null") {
                    item.detail = "-"
                  }

              return (this.columns_date ? item.date.includes(this.filter) : "") ||
                 (this.columns_disaster ? item.disaster.includes(this.filter) : "") ||
                 (this.columns_detail ? item.detail.includes(this.filter) : "") ||
                 (this.columns_event_level ? item.event_level.includes(this.filter) : "") ||
                 (this.columns_event_name ? item.event_name.includes(this.filter) : "") ||
                 (this.columns_location ? item.location.includes(this.filter) : "") ||
                 (this.columns_operating_name ? item.operating_name.includes(this.filter) : "") ||
                 (this.columns_status ? item.status.includes(this.filter) : "")


      });

      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }

      return (this.table)

      }else{
        // console.log("5555")
      this.table = this.cloneTable
      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }
      }
      this.table = this.cloneTable
    },
    // Doe ค้นหา  3/6 จบ

    async search() {
      this.filter='';
      this.cloneTable=[];
      var startdate, enddate;
      this.loading = true;
      if (this.startDate != null && this.startDate != "") {
        const date = new Date(this.startDate);
        const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          date
        );
        const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          date
        );
        const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          date
        );
        startdate = `${ye}-${mo}-${da}`;
      } else {
        startdate = "";
      }

      if (this.toDate != null && this.toDate != "") {
        const date = new Date(this.toDate);
        const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          date
        );
        const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          date
        );
        const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          date
        );
        enddate = `${ye}-${mo}-${da}`;
      } else {
        enddate = "";
      }

      if (this.disasterTypeSelected != null) {
        await this.axios
          .post(`${this.$url_service}/get/report`, {
            body: {
              topic: "get-report-disaster",
              subtopic: "get-report-disaster-detail",
              organize: this.organize_table,
              location: this.responseArea_table,
              start_date: startdate,
              end_date: enddate,
              disaster: this.disasterTypeSelected,
              status: this.disasterStatusSelect.id,
              level: this.checked,
            },
          })
          .then((response) => {
            this.table = response.data.data
            // Doe ค้นหา  4/6 
            this.cloneTable = response.data.data
            // Doe ค้นหา  4/6 

            // Doe : เพิ่ม ลำดับ 3/4
            for (let i = 0; i < this.table.length; i++) { 
              this.table[i]["index"] =i+1;
          }
            // Doe : เพิ่ม ลำดับ 3/4 จบ
          // รวม หน่วยงานหลัก
          var data1 = this.table.map(obj => 
              data1= obj.event_operator_table)
              
              // console.log('data1 ',data1);
          
              for (let index = 0; index < data1.length; index++) {
              const element = data1[index];
                  //  console.log('element 1 ',index,'=',element);
                  //  console.log('element 2 ',index,'=',JSON.parse(element).length);
                  let textAll = ''
                      for (let index = 0; index <JSON.parse(element).length; index++) {

                        const element2 = JSON.parse(element)[index].operating_name;
                        // console.log('element2 ',element2);
                        textAll += `${element2}`;
                      }
                      this.table[index]["operating_name"] = textAll
                // console.log("**** ",this.table)
              }
              
          // Doe : แก้ไข เวลา
          for (let index = 0; index < this.table.length; index++) {

            if (this.table[index].date) {
              const element = this.table[index].date.split("/");
            
            let dateNew = new Date(`${element[1]}/${element[0]}/${element[2]}`)
             
          this.table[index].date = moment(dateNew).locale('th').add(543, 'year').format("LLL")
            }
            
          }
           // Doe : แก้ไข เวลา
          // console.log("this.table  ",this.table)

          // Doe ช่องว่างใส่ ขีด
          for (let index = 0; index < this.table.length; index++) {
            // const element = this.table[index];
            if (this.table[index].date == null) {
              this.table[index].date = "-"
            }
            if (this.table[index].detail == "" || this.table[index].detail == null) {
              this.table[index].detail = "-"
            }
            if (this.table[index].location == "" || this.table[index].location == null) {
              this.table[index].location = "-"
            }
            if (this.table[index].operating_name == "" || this.table[index].operating_name == null) {
              this.table[index].operating_name = "-"
            }
            
          }
          // Doe ช่องว่างใส่ ขีด

          this.setSearchText_Footer()

          });

          if (this.columns_disabled == true) {
            this.table = this.cloneTable
          }else{
            this.table = []
          }

        this.loading = false;
      } else {
        this.table = [];
        if (this.disasterTypeSelected == null) {
          this.error_disaster = true;
        }
        if (this.disasterStatusSelect == null) {
          this.error_disasterStatus = true;
        }
      }
    },
    setSearchText_Footer(){
          this.text_Footer=false;
          
          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.organize_table.length !== 0 ||
              this.responseArea_table.length !== 0 ||
              this.startDate !== "" ||
              this.toDate !== "" ||
              this.disasterTypeSelected.length !== 0 || 
              this.disasterStatusSelect !== null || 
              this.checked.length !== 0  ) {
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if(element.DataName === "หน่วยงานหลัก" && this.organize_table.length !== 0){
                  element.textShow = this.setArray_to_Text(this.organize_table,"organize_name")
                }
                if(element.DataName === "พื้นที่เกิดเหตุ" && this.responseArea_table.length !== 0){
                  element.textShow = this.setArray_to_Text_PAT(this.responseArea_table,"province_name","amphur_name","tambon_name")
                }
                if(element.DataName === "จากวันที่" && this.startDate !== "" ){
                  element.textShow = this.changeDateToThai(this.startDate)
                }
                if(element.DataName === "ถึงวันที่" && this.toDate !== ""){
                  element.textShow = this.changeDateToThai(this.toDate)
                }
                if(element.DataName === "ประเภทสาธารณภัย" && this.disasterTypeSelected.length !== 0){
                  element.textShow = this.setArray_to_Text(this.disasterTypeSelected,"system_name")
                }
                if(element.DataName === "สถานะเหตุการณ์" && this.disasterStatusSelect !== null){
               
                  element.textShow = this.disasterStatusSelect.name
                }
                if(element.DataName === "ระดับความรุนแรง" && this.checked.length !== 0){
                  element.textShow = this.setArray_to_Text(this.checked,null)
                }

                this.text_Footer=true;
              }
          }
    },
    setArray_to_Text(data,name){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name !== null) {
          if (element[name] !== undefined) {
            text += element[name] + ",";
          }
        }else{
          if (element === "0") {
            text += "ไม่ระบุ" + "," 
          }else if (element === "1") {
            text += "ระดับที่ "+ element + "," 
          }else if (element === "2") {
            text += "ระดับที่ "+ element + "," 
          }else if (element === "3") {
            text += "ระดับที่ "+ element + "," 
          }else if (element === "4") {
            text += "ระดับที่ "+ element + "," 
          }else if (element === "5") {
            text += "ระดับที่ "+ element + "," 
          }

        }
      }
      return text.slice(0, -1)
    },
    setArray_to_Text_PAT(data,name_P,name_A,name_T){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name_P !== null) {
          if (element[name_P] !== undefined) {
            text += "จังหวัด : "+element[name_P] + " ";
          }
          if (element[name_A] !== undefined) {
            text += "เขต/อำเภอ : "+element[name_A] + " ";
          }
          if (element[name_T] !== undefined) {
            text += "แขวง/ตำบล : "+element[name_T] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },

    confirmDelete() {
      if (this.organizeDelete != null) {
        this.organize_table = this.organize_table.filter(
          (val) => val !== this.organizeDelete
        );
      }
      if (this.responseAreaDelete != null) {
        this.responseArea_table = this.responseArea_table.filter(
          (val) => val !== this.responseAreaDelete
        );
      }
      this.displayConfirmation = false;
      this.organizeDelete = null;
      this.responseAreaDelete = null;
    },

    clearSearchField() {
      this.organize_table = [];
      this.responseArea_table = [];
      this.disasterTypeSelected = null;
      this.startDate = "";
      this.toDate = "";
      this.disasterStatusSelect = null;
      this.checked = [];
      this.error_disaster = false;
      this.error_disasterStatus = false;
      this.multiSelectClearFilerValue +=1;
      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;
      // Doe ค้นหา
      this.filter='';
      this.cloneTable=[];
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log("temp",temp)
                      this.confirmDelete(temp)
                    }
                  })
    },

    // Doe PDF เลือกได้  5/5  
    EditPDF(){
        this.displayEditPDF = true
        this.columnsSelectorDialog = this.columnsSelector
        
      },
      SaveEditPDF(){

        if(this.columnsSelectorDialog.length <= 4){
        this.PDF_minCellWidthVer = 120 
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
       
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
        }

        this.PDF_minCellWidthHor = 130
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12

        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},
        }
      }else if(this.columnsSelectorDialog.length <= 6){
        
        this.PDF_minCellWidthVer = 80
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
          date:{cellWidth: 80},
          disaster:{cellWidth: 80},
          event_level:{cellWidth:85},
     
        } 

        this.PDF_minCellWidthHor = 100
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12
        
        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},

        }
      }else{
        this.PDF_minCellWidthVer = 70
        this.PDF_FontHeaderVer = 15
        this.PDF_FontBodyVer = 12
        this.PDF_BodySizeSelect = this.PDF_BodySize

        this.PDF_minCellWidthHor = 70
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12
        
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor
      }
        
      this.columnsSelector = this.columnsSelectorDialog

        if (this.columnsSelectorDialog.length == 0) {
          
          this.columns_index = false
          this.columns_date = false
          this.columns_disaster = false
          this.columns_detail = false
          this.columns_event_level = false
          this.columns_event_name = false
          this.columns_location = false
          this.columns_operating_name = false

          this.columns_status = false


          this.columns_disabled = false
        }else if(this.columnsSelectorDialog.length == 9){
            
            this.columns_index = true
            this.columns_date = true
            this.columns_disaster = true
            this.columns_detail = true
            this.columns_event_level = true
            this.columns_event_name = true
            this.columns_location = true
            this.columns_operating_name = true

            this.columns_status = true
            
            this.columns_disabled = true
        }  
        else{
          this.columns_disabled = true
          // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);
          
          
          let getData = []    
          // ! จัดข้อมูล
          for (let index = 0; index < this.columnsSelector.length; index++) {
            getData.push(this.columnsSelector[index].dataKey);
          }
          
          // console.log("getData",getData);

          // ! เช็คข้อมูล

          for (let index = 0; index < this.columnsSelector.length; index++) {
              const element = this.columnsSelector[index].dataKey
        
              if (element == "index") {
                this.columns_index = true
              } else if(!getData.includes("index")){
                // console.log("getData.includes(index)",getData.includes("index"))
                this.columns_index = false
              }

              if (element == "date") {
                this.columns_date = true 
              }else if(!getData.includes("date")){
                
                this.columns_date = false
              }

              if (element == "disaster") {
                this.columns_disaster = true 
              }else if(!getData.includes("disaster")){
                
                this.columns_disaster = false
              }

              if (element == "detail") {
                this.columns_detail = true 
              }else if(!getData.includes("detail")){
                
                this.columns_detail = false
              }

              if (element == "event_level") {
                this.columns_event_level = true 
              }else if(!getData.includes("event_level")){
                
                this.columns_event_level = false
              }

              if (element == "event_name") {
                this.columns_event_name = true 
              }else if(!getData.includes("event_name")){
                
                this.columns_event_name = false
              }

              if (element == "location") {
                this.columns_location = true
              } else if(!getData.includes("location")){
                this.columns_location = false
              }

              if (element == "operating_name") {
                this.columns_operating_name = true 
              }else if(!getData.includes("operating_name")){
                
                this.columns_operating_name = false
              }

              if (element == "status") {
                this.columns_status = true 
              }else if(!getData.includes("status")){
                
                this.columns_status = false
              }

          }

        }

        this.displayEditPDF = false
        this.filter = ""

      },
      CloseEditPDF(){
        this.displayEditPDF = false
      },
      ClearEditPDF(){
        this.columnsSelectorDialog = []
        
      },
      SelectAllEditPDF(){
        this.columnsSelectorDialog = this.columns
        
      },
      // Doe PDF เลือกได้  5/5 จบ

  },
};
</script>

<style scoped>

.table_row{
  text-align: center;
}

.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT{
    width: 149px;
  }
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}
@media screen and (max-width: 430px) {
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-dialog) {
    @media screen and (max-width: 991px) {
      .p-dialog-content{
        overflow-y: auto;
      }
    }
    
  }
.p-multiselect {
  // min-width: 18rem;
  max-width: 50rem;
  // width: fit-content;
}
@media screen and (max-width: 1540px) {
    .p-multiselect {
        max-width: 30rem !important
    }
}

@media screen and (max-width: 640px) {
    .p-multiselect {
        max-width: 10rem !important
    }
}

.multiselect-custom {
  // Doe PDF เลือกได้
  width: 100%;
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    
  }


  

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>
